import { Visitors } from 'components/adding-visitors-block/adding-visitors-block';
import { AttendeeType } from 'store/transactions/types';
import { FormattedAttendees } from 'store/cart/types';

export const formatAttendees = (visitors: Visitors, type: AttendeeType): Array<FormattedAttendees> => {
  return Object.entries(visitors).map(([, email]) => ({ email, type }));
};
